module.exports = __webpack_public_path__ + "img/icon5.b08fd453.png";